import { render, staticRenderFns } from "./ImageDrawCanvas.vue?vue&type=template&id=8c1404cc&scoped=true&"
import script from "./ImageDrawCanvas.vue?vue&type=script&lang=js&"
export * from "./ImageDrawCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ImageDrawCanvas.vue?vue&type=style&index=0&id=8c1404cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1404cc",
  null
  
)

export default component.exports